// eslint-disable-next-line import/no-extraneous-dependencies
import { ViteSSG } from 'vite-ssg'

import { initialDescriptorKey } from '@/composables/useCapitalizedDescriptor'
import { routes } from '@/router/routes'

import App from './App.vue'

export const createApp = ViteSSG(
  App,
  { routes },
  async ({ app, initialState, routePath }) => {
    if (import.meta.env.SSR) {
      initialState.descriptor = routes.find((route) => route.path === routePath)?.meta?.descriptor || ''
    }

    // Personalized HTML is served at /, so preserve its SSG name until mounting.
    app.provide(initialDescriptorKey, initialState.descriptor || '')

    try {
      const { initErrorTracking } = await import('@/utils/initErrorTracking')

      initErrorTracking(app)
    } catch (error) {
      // stub
    }
  },
)
